export interface EmployeeTeam {
  id: number;
  name: string;
  positionName: string;
  office: string;
  parentId: number | undefined;
  manages: number | undefined;
  oversees: number | undefined;
}
